export const COMPANY = {
  name: "Coastal Valet Trash",
  tagline: "Door-to-Door Valet Trash",
  phonePrimary: "(478) 213-5538",
  phonePrimaryRaw: "+14782135538",
  phoneSecondary: "(912) 724-9238",
  phoneSecondaryRaw: "+19127249238",
  email: "coastalvalettrashco@gmail.com",
  founder: "Zuriel Debose",
  founderImage:
    "https://customer-assets.emergentagent.com/job_valet-trash-savannah/artifacts/5m10heij_8BEEDE85-9438-405D-B025-C2BE10A2FD77%20%283%29.jpeg",
};

export const IMAGES = {
  hero: "https://images.pexels.com/photos/31656143/pexels-photo-31656143.jpeg",
  worker:
    "https://images.unsplash.com/photo-1580842402762-6f5868c17412?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBjbGVhbmVyJTIwdW5pZm9ybXxlbnwwfHx8fDE3ODE4MDY4ODh8MA&ixlib=rb-4.1.0&q=85",
  manager:
    "https://images.unsplash.com/photo-1627161683077-e34782c24d81?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBjbGVhbmVyJTIwdW5pZm9ybXxlbnwwfHx8fDE3ODE4MDY4ODh8MA&ixlib=rb-4.1.0&q=85",
  skyline:
    "https://images.pexels.com/photos/19694270/pexels-photo-19694270.jpeg",
};

export const BENEFITS = [
  {
    icon: "Smile",
    title: "Happier Residents",
    text: "Residents enjoy the convenience of doorstep pickup, boosting satisfaction and renewal rates.",
  },
  {
    icon: "Sparkles",
    title: "Cleaner Properties",
    text: "Consistent collection keeps walkways, breezeways, and grounds spotless every day.",
  },
  {
    icon: "TrendingUp",
    title: "Higher Property Value",
    text: "A premium amenity that elevates your community's reputation and competitive edge.",
  },
  {
    icon: "Clock",
    title: "Time Saved",
    text: "Free your on-site team from chasing overflowing dumpsters and trash complaints.",
  },
];

export const SERVICES = [
  {
    icon: "Truck",
    title: "Door-to-Door Trash Collection",
    text: "Scheduled pickup directly from each resident's door, five nights a week.",
  },
  {
    icon: "Building2",
    title: "Apartment Valet Trash Service",
    text: "A turnkey amenity program designed specifically for multi-family communities.",
  },
  {
    icon: "PackageOpen",
    title: "Bulk Item Pickup Coordination",
    text: "We coordinate removal of furniture, appliances, and oversized items with ease.",
  },
  {
    icon: "ClipboardCheck",
    title: "Property Cleanliness Monitoring",
    text: "Routine walkthroughs and reporting to keep your grounds inspection-ready.",
  },
  {
    icon: "Recycle",
    title: "Waste Management Solutions",
    text: "Tailored programs that streamline waste flow and reduce overflow issues.",
  },
  {
    icon: "Boxes",
    title: "Junk Removal Service",
    text: "Fast, hassle-free removal of unwanted junk, debris, and clutter from any property.",
  },
  {
    icon: "Home",
    title: "Foreclosure & Eviction Clean-Outs",
    text: "Full house, apartment, and estate clean-out services for foreclosures, evictions, and property turnovers — cleared out and ready.",
  },
];

export const WHY = [
  {
    icon: "ShieldCheck",
    title: "Reliable Service",
    text: "Consistent, on-time pickups your residents can count on every single night.",
  },
  {
    icon: "BadgeDollarSign",
    title: "Competitive Pricing",
    text: "Transparent, contract-friendly rates built for property budgets.",
  },
  {
    icon: "Users",
    title: "Professional Staff",
    text: "Uniformed, courteous, and background-checked collection professionals.",
  },
  {
    icon: "FileCheck2",
    title: "Fully Insured",
    text: "Complete liability coverage for total peace of mind on your property.",
  },
  {
    icon: "MapPin",
    title: "Local Savannah Business",
    text: "Locally owned and operated, deeply invested in our community.",
  },
];

export const AREAS = [
  { name: "Savannah", state: "Georgia" },
  { name: "Pooler", state: "Georgia" },
  { name: "Port Wentworth", state: "Georgia" },
  { name: "Richmond Hill", state: "Georgia" },
  { name: "Garden City", state: "Georgia" },
];

export const TESTIMONIALS = [
  {
    quote:
      "Coastal Valet Trash transformed our community. Our breezeways have never been cleaner and resident complaints about trash dropped to zero.",
    name: "Marcus Bell",
    role: "Property Manager, Riverside Apartments",
  },
  {
    quote:
      "Dependable, professional, and responsive. Zuriel's team shows up every night without fail. They've made my job so much easier.",
    name: "Danielle Carter",
    role: "Regional Manager, Coastal Living Group",
  },
  {
    quote:
      "Our residents love the convenience and our renewal rates have improved. It's the best amenity we've added in years.",
    name: "Priya Anand",
    role: "Community Director, Pooler Pointe",
  },
  {
    quote:
      "Fully insured, locally owned, and genuinely care about our property. I recommend Coastal Valet Trash to every manager I know.",
    name: "James Whitfield",
    role: "Asset Manager, Harbor Property Partners",
  },
];

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Why Us", href: "#why" },
  { label: "Service Areas", href: "#areas" },
  { label: "Testimonials", href: "#testimonials" },
];
